import { Component, OnInit, EventEmitter, Input, Output } from '@angular/core';
import { I18nService } from '@app/core';
import { Title } from '@angular/platform-browser';
import { AuthService } from '@app/auth.service';
import { Router, NavigationEnd } from '@angular/router';
import { UserService } from '@app/user.service';
import { UtilService } from '@app/utility/util.service';
import { ApiService } from '@app/utility/api.service';
import { forkJoin } from 'rxjs/observable/forkJoin';

declare function loadTree(): any;
declare var $: any;

@Component({
  selector: 'app-mainmenu',
  templateUrl: './mainmenu.component.html',
  styleUrls: ['./mainmenu.component.scss']
})

export class MainmenuComponent implements OnInit {

  menuStr: any;
  member_info: any;
  IsSelect: any;

  ActivatedComponent: string;

  constructor(
    private i18nService: I18nService,
    private titleService: Title,
    private Auth: AuthService,
    private router: Router,
    private user: UserService,
    private util: UtilService,
    private apiService: ApiService
  ) {
    router.events.subscribe((val) => {
      if (val instanceof NavigationEnd) {
        this.SelectMenu(val.url);
      }
    });
  }

  async ngOnInit() {
    let thisTs = this;
    document.body.className = 'sidebar-mini accent-danger';
    this.VerifyRole();
    $('[data-provide="datepicker"]').attr('placeholder', 'DD/MM/YYYY');
    $(".user-menu").on("click", function () {
      thisTs.router.navigate(["/mainmenu/" + this.id]);
    });
    
    await this.CallApi();
  }

  async CallApi() {
    return forkJoin([
      this.InitDropdownItems()
    ]);
  }

  async InitDropdownItems() {
    if (localStorage.getItem("companyType") == null)
      localStorage.setItem("companyType", JSON.stringify(await this.apiService.get("master", "companyType")));
    if (localStorage.getItem("personalType") == null)
      localStorage.setItem("personalType", JSON.stringify(await this.apiService.get("master", "personalType")));
    if (localStorage.getItem("address") == null)
      localStorage.setItem("address", JSON.stringify(await this.apiService.getMasterAddress()));
  }

  SelectMenu(Url: string) {
    this.ActivatedComponent = Url.substring(Url.lastIndexOf('/') + 1, Url.length);
    switch (this.ActivatedComponent) { 
      case "ticketlist": {
        $('#ticketlist').addClass("active");
        $('#register').removeClass("active");
        $('#profile').removeClass("active");
        $('#prereqdocument').removeClass("active");
        break;
      }
      case "register": {
        $('#ticketlist').removeClass("active");
        $('#register').addClass("active");
        $('#profile').removeClass("active");
        $('#prereqdocument').removeClass("active");
        break;
      }
      case "profile": {
        $('#ticketlist').removeClass("active");
        $('#register').removeClass("active");
        $('#profile').addClass("active");
        $('#prereqdocument').removeClass("active");
        break;
      } 
      case "prereqdocument": {
        $('#ticketlist').removeClass("active");
        $('#register').removeClass("active");
        $('#profile').removeClass("active");
        $('#prereqdocument').addClass("active");
        break;
      }
      default: break;
    }
  }

  async VerifyRole() {
    if (!this.Auth.CheckSessionState())
      return;

    let thisTs = this;
    var Profile = await this.Auth.GetProfile(localStorage.getItem("AgentBank_Profile")); //JSON.parse(localStorage.getItem("AgentBank_Profile"))[0];
    var Role = await this.Auth.GetRole(Profile[0]["dpa_roleid"]);
    if (Role[0]["dpa_access_ticketlist"] == false) {
      $('#MenuTicketList').addClass("hidden");
    }
    if (Role[0]["dpa_access_register"] == false) {
      $('#MenuRegister').addClass("hidden");
    }
    if (Role[0]["dpa_access_profile"] == false) {
      $('#MenuProfile').addClass("hidden");
    }
  }
  
  async Logout() {
    localStorage.removeItem("AgentBank_Profile");
    this.Auth.setLoggedIn(false);
    this.router.navigate(['login']);
  }

  ClaerActiveTabMenu() {
    $(".user-menu").each(function () {
      $(this).prop("aria-selected", false)
      $(this).removeClass("active")
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/mainmenu/mainmenu.component.ts